<template>
  <div :class="[{ 'data-loading': !catalogData }]">
    <WCatalog
      v-if="catalogData"
      :id="id"
      :catalog="catalogData"
      class="home-catalog"
    />
  </div>
</template>

<script>
  import WCatalog from '@/views/home/WCatalog.vue'
  import { onDisplay } from '@/common/directives'
  import { onMounted, ref } from 'vue'
  import { getMyHomeData } from '@/common/requests/data-fetch/'

  export default {
    // directive 때문에 vue2, vue3 문법 혼재 -> vue3 standard 문법으로 변경 (setup x)
    components: {
      WCatalog,
    },
    directives: {
      onDisplay,
    },
    setup() {
      const catalogData = ref()
      const id = ref('')

      const init = async () => {
        const { data: myData } = await getMyHomeData()
        if (myData) {
          const { catalog } = myData?.layout
          catalogData.value = catalog ?? {}

          id.value = myData?.id ?? ''
        }
      }

      onMounted(() => {
        init()
      })

      return {
        catalogData,
        id,
      }
    },
  }
</script>

<style lang="scss" scoped></style>
